
import React from 'react';
import Logo from './Logo';

const Header: React.FC = () => {
  return (
    <header className="fixed w-full top-0 z-50 bg-[#0f0a24]/90 backdrop-blur-xl border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center items-center h-28">
          <Logo />
        </div>
      </div>
    </header>
  );
};

export default Header;
